import React, { useState } from "react";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaEmptyState from "../../../../ui-kit/kuika-empty-state/kuika-empty-state";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

// Remounts the two variants so their once-on-mount entrance can be watched again.
const Replay: React.FC = (): JSX.Element => {
  const [run, setRun] = useState<number>(0);
  return (
    <div className="lab-stack" style={{ gap: 16, alignItems: "flex-start", width: "100%" }}>
      <KuikaButton type="secondary" size="sm" onClick={(): void => setRun(run + 1)}>
        Replay entrance
      </KuikaButton>
      <div key={`panel-${run}`} style={{ width: 320 }}>
        <KuikaEmptyState svgName="database-search" name="datasource" action="Add datasource" />
      </div>
      <div key={`page-${run}`} style={{ width: 420 }}>
        <KuikaEmptyState
          svgName="search"
          customName="No apps added to favorites"
          description="Once you favorite your apps, they will appear here for easy access."
          variant="page"
          footer={
            <KuikaButton type="primary" size="md">
              Browse apps
            </KuikaButton>
          }
        />
      </div>
    </div>
  );
};

export const EmptyStateStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Empty State"
      componentName="KuikaEmptyState"
      sourcePath="ui-kit/kuika-empty-state"
      description="Illustrated empty placeholder. Customisable icon, action verb and past-tense suffix drive the copy. Enters once when it mounts — a re-render never replays it."
    >
      <SpecRow
        label="Entrance"
        caption="panel variant rises as one card; page variant staggers icon → title → description → footer. Reduced motion keeps only the fade"
        align="start"
      >
        <Replay />
      </SpecRow>
      <SpecRow label="Default" align="start">
        <KuikaEmptyState svgName="database-search" name="datasource" action="Add datasource" />
      </SpecRow>
      <SpecRow label="Custom past tense" caption="pastTense='created'" align="start">
        <KuikaEmptyState svgName="screen" name="screen" pastTense="created" action="Create screen" />
      </SpecRow>
      <SpecRow label="Hide description" caption="hideDescription — only title + action" align="start">
        <KuikaEmptyState svgName="bolt" name="action" action="Add action" hideDescription />
      </SpecRow>
      <SpecRow
        label="Raw tile size"
        caption="svgWidth/svgHeight — off the tile ladder; the radius follows the width"
        align="start"
      >
        <KuikaEmptyState svgName="folder-check" name="folder" action="New folder" svgWidth={72} svgHeight={72} />
      </SpecRow>
      <SpecRow label="customName override" align="start">
        <KuikaEmptyState
          svgName="components"
          name="component"
          customName="reusable component"
          action="Add reusable component"
        />
      </SpecRow>
    </ShowcaseFrame>
  );
};
